
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './Table.html?raw';

import _WidgetBaseSP from 'more/_WidgetBaseSP';
import _TabEnabledMixin from '../../../../../moreCore/UI/Tabbing/_TabEnabledMixin';
import ItemTableView from '../ItemTableView/ItemTableView';


class Table extends compose(_WidgetBaseSP, _TabEnabledMixin) {
    templateString: any = template;

    title: string = null;
    tableContainer: HTMLDivElement;
    table: MdsLax<InstanceType<typeof ItemTableView>>;
  
    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);

    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.table = new ItemTableView();
        this.table.placeAt(this.tableContainer);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);

    }
}

export default mdsWidget(Table);